import { Outlet, Routes, useLocation } from "react-router-dom";
import { FSLoader, Result } from "../components";
import { useAuth, useGeneral } from "../hooks";
import Route, { createRoute } from "./route";
import { Constants, Enums } from "../utils";
import Localization from "../localization";
import React, { useEffect } from "react";
import { Header } from "../layouts";
import {
  PurchaseSubscription,
  ServicePaymentPlans,
  Authentication,
  Subscriptions,
  ResetPassword,
  Subscription,
  OtherDevice,
  Activate,
  Feedback,
} from "../pages";

const AppRoute = ({ isAuthenticated }) => {
  return isAuthenticated ? <Outlet /> : <Authentication />;
};

const Router = () => {
  const { isSafelandMobileApp } = useGeneral();
  const { isAuthenticated } = useAuth();
  const { pathname } = useLocation();

  useEffect(() => {
    scrollScreenToTop();
  }, [pathname]);

  const scrollScreenToTop = () => {
    const app = document.getElementById("app");
    if (!!app?.scrollTo) app.scrollTo(0, 0);
  };

  if (isAuthenticated === undefined) return <FSLoader />;
  return (
    <>
      {isAuthenticated &&
        ![Enums.pagesNames.resetPassword].includes(pathname.replace("/", "")) &&
        !isSafelandMobileApp && <Header path={pathname} />}
      <Routes>
        <Route element={<AppRoute isAuthenticated={isAuthenticated} />}>
          {createRoute({
            Component: Subscription,
            redirectFrom: "service/:uuid",
            path: Enums.pagesNames.subscription + "/:uuid",
          })}
          <Route path={"/"} Component={Subscriptions} />,
          <Route path={Enums.pagesNames.feedback} Component={Feedback} />
          <Route
            Component={ServicePaymentPlans}
            path={Enums.pagesNames.servicePaymentPlans}
          />
        </Route>
        {createRoute({
          redirectFrom: "services",
          Component: PurchaseSubscription,
          path: Enums.pagesNames.purchaseSubscription,
        })}
        <Route path={Enums.pagesNames.activate} Component={Activate} />
        <Route
          Component={Activate}
          path={Enums.pagesNames.activate + "/:uuid"}
        />
        <Route
          Component={ResetPassword}
          path={Enums.pagesNames.resetPassword}
        />
        <Route
          Component={OtherDevice}
          path={Enums.pagesNames.otherDevice + "/:uuid"}
        />
        <Route
          path={"*"}
          element={
            <Result
              status="404"
              title={Localization.not_found.title}
              subTitle={Localization.not_found.desc}
            />
          }
        />
      </Routes>
    </>
  );
};

export default Router;
